// Base da API.
// - Em container/produção: REACT_APP_API_URL fica vazio -> usa caminho relativo
//   "/api", que o nginx encaminha (proxy reverso) para o serviço backend.
// - Em desenvolvimento: defina REACT_APP_API_URL (ex.: http://192.168.1.28:8091
//   ou http://localhost:8091) num arquivo .env do frontend.
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || "";
};

// URL base da API
export const API_BASE = getApiBaseUrl();

console.log("🔧 API Base URL configurada:", API_BASE || "(relativa: /api -> proxy nginx)");
